const mapITRisk = ({
	itApplicationId,
	itRiskId,
	itRiskName,
	hasNoITGC,
	itProcessParentTypeId,
	itProcessTypeId,
	rejectionTypeId,
	rejectionRationale,
	isRejected,
	isCustom,
	isDisplayed,
	itProcesses
}) => ({
	itApplicationId,
	itRiskId,
	itRiskName,
	hasNoITGC,
	itProcessParentTypeId,
	itProcessTypeId,
	rejectionTypeId,
	rejectionRationale,
	isRejected,
	isCustom,
	isDisplayed,
	itProcesses
});

const mapAttribute = ({
	itApplicationId,
	itApplicationAttributeId,
	itApplicationAttributeName,
	itProcessTypeId,
	knowledgeDisplayOrder,
	isSelected,
	itRisks = []
}) => {
	return {
		itApplicationId,
		itApplicationAttributeId,
		itApplicationAttributeName,
		itProcessTypeId,
		knowledgeDisplayOrder,
		isSelected,
		itRisks: itRisks.map(mapITRisk)
	};
};

export default (response) => {
	const data = response?.data?.[0] ?? {};
	const {itApplicationAttributes = []} = data;
	return itApplicationAttributes?.map(mapAttribute) ?? [];
};
